import { Box, Skeleton, Typography } from "@mui/material";
import { amountType } from "../../theme/main";

/**
 * A figure in the expanded amount type; its currency sign keeps the normal width (wide, "$" reads as an "s")
 */
export const FigureText = ({ children }) => {
  const match = typeof children === "string" ? children.match(/^([<>]?\$)(.*)$/) : null;
  if (!match) return children;
  return (
    <>
      <Box component="span" sx={{ fontStretch: "100%", mr: "0.04em" }}>
        {match[1]}
      </Box>
      {match[2]}
    </>
  );
};

/**
 * Headline figures in one strip: label above, value below
 * items: [{ label, value }]; value null while loading
 */
const StatsRow = ({ items }) => (
  <Box
    component="dl"
    sx={{
      m: 0,
      display: "grid",
      gridTemplateColumns: { xs: "1fr 1fr", md: `repeat(${items.length}, minmax(0, 1fr))` },
      border: 1,
      borderColor: "divider",
      borderRadius: "16px",
      bgcolor: "background.paper",
      overflow: "hidden",
    }}
  >
    {items.map((item, index) => (
      <Box
        key={item.label}
        sx={{
          px: 2.5,
          py: 2,
          minWidth: 0,
          // hairlines between the cells: a column on desktop, a 2 x 2 grid on mobile
          borderLeft: { xs: index % 2 ? 1 : 0, md: index ? 1 : 0 },
          borderTop: { xs: index > 1 ? 1 : 0, md: 0 },
          borderColor: { xs: "divider", md: "divider" },
        }}
      >
        <Typography component="dt" variant="body2" sx={{ color: "text.secondary", mb: 0.5 }}>
          {item.label}
        </Typography>
        <Typography
          component="dd"
          noWrap
          sx={{
            m: 0,
            ...amountType,
            // standalone figures use proportional digits; tabular ones are for columns
            fontVariantNumeric: "proportional-nums",
            fontSize: { xs: "1.25rem", md: "1.5rem" },
          }}
        >
          {item.value === null || item.value === undefined ? (
            <Skeleton width="60%" />
          ) : (
            <FigureText>{item.value}</FigureText>
          )}
        </Typography>
      </Box>
    ))}
  </Box>
);

export default StatsRow;
